module.exports = __webpack_public_path__ + "img/remisAD.69f285c9.png";